/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InstrumentCategory {
    ALL = 'All',
    COMMODITIES = 'Commodities',
    INDICES = 'Indices',
    SHARES = 'Shares',
    FAVORITES = 'Favorites',
}
